(function () {
  'use strict';
  var cfg = window.BH_V2_BRIDGE;
  if (!cfg) return;

  var IS_MAGNET = cfg.isMagnet === true || cfg.isMagnet === 'true';
  var ebookSku = cfg.ebookSku;
  var audioSku = cfg.audioSku;
  var bhPageId = cfg.bhPageId;
  var pageRoot = document.querySelector('.bh-page-' + bhPageId);
  if (!pageRoot) return;

  var ids = ['bhPrimaryActionDesktop-' + bhPageId, 'bhPrimaryActionMobile-' + bhPageId];

  var cachedSigninCode = null;
  var signinCodeRefreshStarted = false;

  function getCookie(name) {
    var m = document.cookie.match(new RegExp('(?:^|; )' + name.replace(/[.$?*|{}()[\]\\\/+^]/g, '\\$&') + '=([^;]*)'));
    return m ? decodeURIComponent(m[1]) : null;
  }

  function decodeJwt(t) {
    try {
      var parts = t.split('.');
      if (parts.length < 2) return null;
      var b64 = parts[1].replace(/-/g, '+').replace(/_/g, '/');
      while (b64.length % 4) b64 += '=';
      var json = decodeURIComponent(atob(b64).split('').map(function (c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
      }).join(''));
      return JSON.parse(json);
    } catch (e) { return null; }
  }

  function stageFromClaims(c) {
    if (!c) return null;
    var fields = [c['Account.AccountStage'], c.AccountStage, c.accountStage,
                  c.nocode && c.nocode.accountStage, c['outseta:accountStage'],
                  c.Account && c.Account.AccountStage];
    for (var i = 0; i < fields.length; i++) {
      var v = fields[i];
      if (v == null || v === '') continue;
      var n = parseInt(v, 10);
      if (!isNaN(n)) return n;
      var s = String(v).toLowerCase();
      if (s === 'trialing') return 2;
      if (s === 'subscribing') return 3;
      if (s === 'cancelled' || s === 'canceled' || s === 'expired') return 4;
    }
    return null;
  }

  function hideButtons() {
    for (var i = 0; i < ids.length; i++) {
      var b = document.getElementById(ids[i]);
      if (b) b.style.display = 'none';
    }
  }

  function hideSecondaryAndNotes() {
    var secondaries = document.querySelectorAll('.bh-btn-secondary-' + bhPageId);
    for (var i = 0; i < secondaries.length; i++) secondaries[i].style.display = 'none';
    var notes = document.querySelectorAll('.bh-trial-note-' + bhPageId);
    for (var j = 0; j < notes.length; j++) notes[j].style.display = 'none';
  }

  function injectAuthPills() {
    var anchors = [];
    for (var i = 0; i < ids.length; i++) {
      var b = document.getElementById(ids[i]);
      if (b && b.parentNode) anchors.push(b);
    }
    if (!anchors.length) return;
    var ret = window.location.pathname + window.location.search;
    try { sessionStorage.setItem('bh_return_to', ret); } catch (e) {}
    for (var j = 0; j < anchors.length; j++) {
      var anchor = anchors[j];
      if (anchor.parentNode.querySelector('.bh-auth-pills')) continue;
      var wrap = document.createElement('div');
      wrap.className = 'bh-auth-pills';
      wrap.style.cssText = 'display:flex;gap:0.5rem;margin-bottom:0.75rem;';
      var signUp = document.createElement('a');
      signUp.href = '/pages/plans';
      signUp.textContent = 'Sign Up';
      signUp.className = 'bh-btn-' + bhPageId + ' bh-btn-primary-' + bhPageId;
      signUp.style.flex = '1';
      var signIn = document.createElement('a');
      signIn.href = '/pages/account-information';
      signIn.textContent = 'Sign In';
      signIn.className = 'bh-btn-' + bhPageId + ' bh-btn-secondary-' + bhPageId;
      signIn.style.flex = '1';
      wrap.appendChild(signUp);
      wrap.appendChild(signIn);
      anchor.parentNode.insertBefore(wrap, anchor);
    }
  }

  function applyState(stage, loggedIn) {
    window.__bhState = { stage: stage, loggedIn: loggedIn };
    if (!loggedIn) {
      hideButtons();
      hideSecondaryAndNotes();
      injectAuthPills();
      return;
    }
    var hideOpen = (stage === 2 && !IS_MAGNET) || (stage != null && stage >= 4);
    if (hideOpen) hideButtons();
    // Subscriber: no upsell needed. Trialer on a magnet title: only the read
    // CTA, no competing Upgrade. (Trialer on non-magnet keeps Upgrade visible.)
    if (stage === 3 || (stage === 2 && IS_MAGNET)) hideSecondaryAndNotes();
    // Bake a fresh signinCode into the Open Reader/Player href so the app's
    // QR-SSO handler signs the user in when iOS UL fires from a tap. Only
    // when the Open button is actually visible to the user.
    if (!hideOpen) startSigninCodeRefresh();
  }

  function watchForLateCookie() {
    var attempts = 0;
    var poll = setInterval(function () {
      attempts++;
      if (getCookie('Outseta.nocode.accessToken')) {
        clearInterval(poll);
        window.location.reload();
      } else if (attempts > 15) {
        clearInterval(poll);
      }
    }, 200);
  }

  function resolveState() {
    var token = getCookie('Outseta.nocode.accessToken');
    if (!token) { applyState(null, false); watchForLateCookie(); return; }
    var jwtStage = stageFromClaims(decodeJwt(token));
    if (jwtStage != null) { applyState(jwtStage, true); return; }
    var url = 'https://5ewa0lrtvd.execute-api.us-west-2.amazonaws.com/entitlement/check';
    fetch(url, {
      headers: { Authorization: 'Bearer ' + token, Accept: 'application/json' },
      credentials: 'omit'
    }).then(function (r) {
      if (!r.ok) throw new Error('HTTP ' + r.status);
      return r.json();
    }).then(function (result) {
      var stage = (typeof result.stage === 'number') ? result.stage : null;
      applyState(stage, true);
    }).catch(function () { applyState(null, true); });
  }

  resolveState();

  function activeFormat() {
    var el = pageRoot.querySelector('[data-format].is-active');
    return el ? el.getAttribute('data-format') : 'eBook';
  }

  function buildAction() {
    var fmt = activeFormat();
    var isAudio = fmt === 'Audiobook';
    var sku = isAudio ? audioSku : ebookSku;
    if (!sku) return null;
    var bookId = (isAudio ? 'audio-' : 'ebook-') + sku;
    var path = isAudio ? '/listen' : '/open';
    return {
      type: isAudio ? 'open-player' : 'open-reader',
      bookId: bookId,
      url: 'https://enjoy.brighthavenbooks.com' + path + '?bookId=' + encodeURIComponent(bookId)
    };
  }

  function updateHrefs() {
    var action = buildAction();
    if (!action) return;
    var url = action.url;
    if (cachedSigninCode) {
      url += (url.indexOf('?') === -1 ? '?' : '&') + 'signinCode=' + encodeURIComponent(cachedSigninCode);
    }
    window.__bhAction = { type: action.type, bookId: action.bookId, url: url, format: activeFormat() };
    var label = action.type === 'open-player' ? 'Open player' : 'Open reader';
    for (var i = 0; i < ids.length; i++) {
      var b = document.getElementById(ids[i]);
      if (b) { b.href = url; b.textContent = label; }
    }
  }

  function startSigninCodeRefresh() {
    if (signinCodeRefreshStarted) return;
    signinCodeRefreshStarted = true;
    function refresh() {
      issueSigninCode(function (code) {
        cachedSigninCode = code;
        updateHrefs();
      });
    }
    refresh();
    setInterval(refresh, 4 * 60 * 1000);
  }

  function isDesktop() {
    var ua = navigator.userAgent || '';
    return !/iPhone|iPad|iPod|Android/i.test(ua);
  }

  function ensureQRLib(cb) {
    if (typeof window.QRCode === 'function') return cb();
    var s = document.createElement('script');
    s.src = (window.BH_V2_BRIDGE && window.BH_V2_BRIDGE.qrLibUrl) || '/cdn/shop/t/18/assets/app-v2-qrcode.min.js';
    s.onload = cb;
    s.onerror = cb;
    document.head.appendChild(s);
  }

  function issueSigninCode(cb) {
    var token = getCookie('Outseta.nocode.accessToken');
    if (!token) return cb(null);
    fetch('https://vtfi7hw6b1.execute-api.us-west-2.amazonaws.com/prod/auth/qr-issue', {
      method: 'POST',
      headers: { 'Authorization': 'Bearer ' + token, 'Content-Type': 'application/json' }
    }).then(function (r) {
      if (!r.ok) return cb(null);
      return r.json();
    }).then(function (d) { cb(d && d.code ? d.code : null); })
      .catch(function () { cb(null); });
  }

  function showQRModal(baseUrl) {
    var existing = document.getElementById('bh-qr-modal');
    if (existing) existing.remove();
    var modal = document.createElement('div');
    modal.id = 'bh-qr-modal';
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-modal', 'true');
    modal.style.cssText = 'position:fixed;inset:0;z-index:10000;display:flex;align-items:center;justify-content:center;';
    modal.innerHTML =
      '<div class="bh-qr-backdrop" style="position:absolute;inset:0;background:rgba(0,0,0,0.55);"></div>' +
      '<div class="bh-qr-card" style="position:relative;background:#fff;border-radius:12px;padding:2rem;max-width:420px;text-align:center;box-shadow:0 20px 60px rgba(0,0,0,0.3);">' +
      '  <button class="bh-qr-close" aria-label="Close" style="position:absolute;top:0.5rem;right:0.75rem;background:transparent;border:none;font-size:2.25rem;cursor:pointer;line-height:1;">&times;</button>' +
      '  <h3 style="margin:0 0 0.5rem;font-size:1.6rem;">Open in the Bright Haven app</h3>' +
      '  <p style="margin:0 0 1.5rem;font-size:1.15rem;color:rgba(0,0,0,0.7);">Scan with your phone to open this book.</p>' +
      '  <div id="bh-qr-target" style="display:flex;justify-content:center;"></div>' +
      '  <p id="bh-qr-countdown" style="margin:1rem 0 0;font-size:25px;opacity:0.7;">&nbsp;</p>' +
      '</div>';
    document.body.appendChild(modal);
    var QR_TTL = 300;
    var timer = null;
    var close = function () { if (timer) { clearInterval(timer); timer = null; } modal.remove(); };
    modal.querySelector('.bh-qr-backdrop').addEventListener('click', close);
    modal.querySelector('.bh-qr-close').addEventListener('click', close);

    function renderQR(url) {
      var target = document.getElementById('bh-qr-target');
      if (!target) return;
      target.innerHTML = '';
      if (typeof window.QRCode === 'function') {
        new window.QRCode(target, { text: url, width: 200, height: 200, correctLevel: window.QRCode.CorrectLevel ? window.QRCode.CorrectLevel.M : 0 });
      } else {
        target.textContent = url;
      }
    }

    function startCountdown() {
      var startedAt = Date.now();
      if (timer) clearInterval(timer);
      timer = setInterval(function () {
        if (!document.body.contains(modal)) { clearInterval(timer); return; }
        var c = document.getElementById('bh-qr-countdown');
        var remaining = QR_TTL - Math.floor((Date.now() - startedAt) / 1000);
        if (remaining <= 0) {
          clearInterval(timer);
          if (c) c.textContent = 'Refreshing…';
          loadFreshCode();
          return;
        }
        if (c) {
          var mm = Math.floor(remaining / 60);
          var ss = remaining % 60;
          c.textContent = 'Refreshes in ' + mm + ':' + (ss < 10 ? '0' : '') + ss;
        }
      }, 1000);
    }

    function loadFreshCode() {
      var c = document.getElementById('bh-qr-countdown');
      if (c) c.textContent = 'Loading…';
      issueSigninCode(function (code) {
        if (!document.body.contains(modal)) return;
        var url = baseUrl + (code ? (baseUrl.indexOf('?') === -1 ? '?' : '&') + 'signinCode=' + encodeURIComponent(code) : '');
        ensureQRLib(function () { renderQR(url); startCountdown(); });
      });
    }

    loadFreshCode();
  }

  function handle(e) {
    if (window.ReactNativeWebView && window.ReactNativeWebView.postMessage) {
      e.preventDefault();
      var action = buildAction();
      if (action) window.ReactNativeWebView.postMessage(JSON.stringify({type: action.type, bookId: action.bookId}));
      return;
    }
    if (isDesktop()) {
      e.preventDefault();
      var action = buildAction();
      if (!action) return;
      showQRModal(action.url);
      return;
    }
    if (cachedSigninCode) return;
    if (!getCookie('Outseta.nocode.accessToken')) return;
    e.preventDefault();
    var btn = e.currentTarget;
    var originalLabel = btn.textContent;
    btn.textContent = 'Opening...';
    btn.style.opacity = '0.6';
    btn.style.pointerEvents = 'none';
    issueSigninCode(function (code) {
      btn.textContent = originalLabel;
      btn.style.opacity = '';
      btn.style.pointerEvents = '';
      if (code) {
        cachedSigninCode = code;
        updateHrefs();
      }
      window.location.href = btn.href;
    });
  }

  updateHrefs();

  if (getCookie('Outseta.nocode.accessToken')) {
    startSigninCodeRefresh();
  }

  var toggles = pageRoot.querySelectorAll('[data-format]');
  for (var t = 0; t < toggles.length; t++) {
    toggles[t].addEventListener('click', function () { setTimeout(updateHrefs, 0); });
  }

  for (var i = 0; i < ids.length; i++) {
    var btn = document.getElementById(ids[i]);
    if (btn) btn.addEventListener('click', handle);
  }
})();
